import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Input from 'components/Input'
import Select from 'components/Select'
import Button from 'components/Button'
import InputFile from 'components/InputFile'
import DateInput from 'components/DateInput'

import { POLICY_FILE_URL, POLICY_DETAIL_URL, INSCURANCE_COVERAGES_URL } from 'constants'

import { edittingPolicyChanged } from 'scenes/VehicleDetail/components/Policy/actions'
import { refreshPolicy, policyChange } from 'scenes/VehicleDetail/actions'
import { statusChanged } from 'components/RequestStatus/actions'

export class EditForm extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      _company: null,  // read only
      coverages: [],
      formData: {
        broker: null,
        issued_date: props.policy.issued_date,
        expiration_date: props.policy.expiration_date,
        holder_name: props.policy.holder_name,
        first_charge_date: props.policy.issued_date,
        coverage: props.policy.coverage_id,
        custom_coverage: props.policy.custom_coverage,
        periodicity_type: props.policy.periodicity_type
      },
      policyFile: {
        message: 'No se ha seleccionado archivo',
        file: '',
        status: false
      }
    }

    this._bind(
      '_fetchPolicyDetail', '_onSubmit', '_handleFileClick', '_handleFileChange',
      '_onBrokerChange', '_onDateChange', '_fetchCoverages', '_fetchPeriodicicty',
      '_onPeriodicityChange', '_onCoverageChange', '_filterCoverages')
  }

  componentDidMount() {
    this._fetchPolicyDetail()
  }

  /*
   * Our API has a bad design returning `strings` instead of related objects
   * so we can use previously retrieved Policy Object to set `selectedOption`
   * on <Select>s thats why we need to retrieve policy detail each time we enter edit mode
   */
  _fetchPolicyDetail() {
    request(POLICY_DETAIL_URL(this.props.userId, this.props.vehicleId, this.props.policy.id))
    .then(({policy}) => {
      this.setState({
        _company: policy.company,
        formData: {
          ...this.state.formData,
          broker: policy.broker
        }
      })
    })
    .catch(console.log)
  }

  _fetchCoverages(label) {
    return request(`${INSCURANCE_COVERAGES_URL}`)
    .then(({coverages}) => {
      this.setState({ coverages })
    })
    .catch(console.log)
  }

  _filterCoverages() {
    let cvs = this.state.coverages
    if ( this.state._company ) {
      cvs = cvs.filter((coverage) => { 
        return ( coverage.company === this.state._company ) && ( coverage.type !== 'Otro' )
      })
    }
    let options = cvs.map((coverage) => ({value: coverage.id, label: coverage.type}))
    return options
  }

  _fetchPeriodicicty(label) {
    this._fetchCoverages()
    const frequencies = ["Catorcenal", "Mensual", "Semestral", "Anual"]
    const options = frequencies.map((f) => ({value: f, label: f}))
    return new Promise(resolve => {
        resolve({options})
    })
  }

  _onSubmit(evt) {
    evt.preventDefault()
    this.props.updateRequestStatus('progress', 'Actualización de poliza en progreso')
    request(POLICY_DETAIL_URL(this.props.userId, this.props.vehicleId, this.props.policyId), {
      method: 'PUT',
      body: {
        ...this.state.formData
      }
    })
    .then((res) => {
      this.props.updateRequestStatus('ok', 'Actualizado con éxito')
      this.props.edittingPolicyChanged(false)
      // if there isn't a file to upload, refresh policy
      if( !this.state.policyFile.status )
        this.props.refreshPolicy()
    })
    .catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos completar la actualización')
    })

    if(this.state.policyFile.status) { this._updateFile() }
  }

  _handleFileClick(e) {
    e.preventDefault()
    this.inputPicture.click()
  }

  _handleFileChange(e) {
    e.preventDefault()
    this.setState({
      policyFile: {
        message: 'Archivo seleccionado',
        file: e.target.files[0],
        status: true
      }
    })
  }

  _updateFile() {
    let formData = new FormData()
    formData.append('file', this.state.policyFile.file)
    this.props.updateRequestStatus('progress', 'Actualizando archivo de poliza...')

    request(POLICY_FILE_URL(this.props.userId, this.props.vehicleId, this.props.policyId), {
      method: 'PUT',
      isUpload: true,
      body: formData
    })
    .then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.refreshPolicy()
    })
    .catch((err) => {
      this.props.updateRequestStatus('error', err.message)
    })
  }

  _onBrokerChange(broker = null) {
    this.setState({
      formData: {
        ...this.state.formData,
        broker: !!broker ? broker.value : null
      }
    })
  }

  _onDateChange(evt) {
    if ( evt.target.name === "issued_date" ) {
      this.setState({
        formData: {
          ...this.state.formData,
          issued_date: evt.target.value,
          first_charge_date: evt.target.value
        }
      })
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [evt.target.name]: evt.target.value
        }
      })
    }
  }

  _onPeriodicityChange(periodicity_type=null) {
    this.setState({
      formData: {
        ...this.state.formData,
        periodicity_type: !!periodicity_type ? periodicity_type.value : null
      }
    })
  }

  _onCoverageChange(coverage=null) {
    this.setState({
      formData: {
        ...this.state.formData,
        coverage: !!coverage ? coverage.value : null
      }
    })
  }

  render() {
    const policy = this.props.policy

    return (
      <form onSubmit={this._onSubmit} className="PolicyData__form">
        <div className="form-field">
          <label>Numero de póliza:</label>
            <Input
              placeholder="Numero de póliza"
              defaultValue={policy.number}
              disabled
            />
        </div>
        <div className="form-field">
          <label>Aseguradora:</label>
          <Select
            disabled
            options={this.props.companies}
            placeholder="Aseguradora"
            value={this.state._company}
          />
        </div>
        <div className="form-field">
          <label>Fecha de expedición</label>
          <div className="DayFieldPicker__wrapper">
            <DateInput
              name="issued_date"
              onChange={this._onDateChange}
              value={this.state.formData.issued_date} />
          </div>
        </div>
        <div className="form-field">
          <label>Fecha de vigencia</label>
          <div className="DayFieldPicker__wrapper">
            <DateInput
              name="expiration_date"
              onChange={this._onDateChange}
              value={this.state.formData.expiration_date} />
          </div>
        </div>
        <div className="form-field">
          <label>Agente Asegurador:</label>
          <Select
            onChange={this._onBrokerChange}
            options={this.props.brokers}
            placeholder="Agente asegurador"
            value={this.state.formData.broker}
          />
        </div>
        <div className="form-field">
          <label>Titular:</label>
          <Input  
                onChange={this._onDateChange}
                name="holder_name"
                value={this.state.formData.holder_name}
                placeholder="Nombre del titular"/>          
        </div>
        <div className="form-field">
          <label>Frecuencia de cobro:</label>
          <Select
            onChange={this._onPeriodicityChange}
            loadOptions={this._fetchPeriodicicty}
            placeholder="Frecuencia de cobro"
            value={this.state.formData.periodicity_type}
          />
        </div>
        <div className="form-field">
          <label>Cobertura:</label>
          <Select
            onChange={this._onCoverageChange}
            options={this._filterCoverages()}
            placeholder="Cobertura"
            value={this.state.formData.coverage}
          />
        </div>
        <div className="form-field">
          <label>Archivo de póliza:</label>
          <InputFile
            file={this.state.policyFile}
            onChange={this._handleFileChange}
          />
        </div>

        <div className="controls d-flex justify-content-end">
          <Button size="small">Actualizar datos</Button>
        </div>
      </form>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    policy: state.vehicleDetail.get('policy').toObject()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    edittingPolicyChanged: (editting) => dispatch(edittingPolicyChanged(editting)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    policyChange: (policy) => dispatch(policyChange(policy)),
    refreshPolicy: () => dispatch(refreshPolicy()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditForm)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/PolicyData/EditForm.js